// Accounts API endpoints

import apiClient from './client';

export const accountsAPI = {
  /**
   * Get all accounts
   * @param {Object} params - Query params (e.g., { stop: 0 } for active only)
   * @returns {Promise}
   */
  getAll: (params = {}) => apiClient.get('/accounts', { params }),

  /**
   * Get active accounts only
   * @returns {Promise}
   */
  getActive: () => apiClient.get('/accounts', { params: { stop: 0 } }),

  /**
   * Get single account
   * @param {number} id - Account ID
   * @returns {Promise}
   */
  getById: (id) => apiClient.get(`/accounts/${id}`),

  /**
   * Create account
   * @param {Object} data - { name, sage, address, phone, email }
   * @returns {Promise}
   */
  create: (data) => apiClient.post('/accounts', data),

  /**
   * Update account
   * @param {number} id - Account ID
   * @param {Object} data - Account data
   * @returns {Promise}
   */
  update: (id, data) => apiClient.patch(`/accounts/${id}`, data),

  /**
   * Delete account
   * @param {number} id - Account ID
   * @returns {Promise}
   */
  delete: (id) => apiClient.delete(`/accounts/${id}`)
};
